<div class="tw-flex tw-flex-column tw-gap-3">
  <ng-container *ngFor="let provider of providers">
    <button
      class="tw-w-full btn-reset tw-px-3 provider-btn tw-flex tw-items-center tw-gap-3"
      [ngClass]="provider"
      type="button"
      (click)="providerClicked(provider)">
      <mg-text
        variant="body-sm"
        element="label"
        >Sign in with {{ provider | titlecase }}</mg-text
      >
    </button>
  </ng-container>
</div>
